import {
  ConfigurationFormType,
  ConfigurationPageTables,
  ConfigurationPageType,
  ConfigurationTableFilterType,
} from "../interfaces";
import { FormatType } from "../../Alert/Filter/FilterType";

const SURQUAL_CUSTOMER_TYPE_PAGE_CUSTOMER_TYPE_TAB: ConfigurationPageTables = {
  description: "CONF_DESC_SELFMAPPING_CUSTOMER_TYPE",
  type: ConfigurationPageType.TABLE,
  label: "CUSTOMER_TYPE",
  path: "",
  model: {
    entityName: "short_name",
    label: "CUSTOMER_TYPE",
    path: "/api/customer-types",
    name: "Customer type",
    attributes: [
      {
        className: "greyText",
        key: "code",
        order: 1,
        label: "CODE",
        visible: true,
      },
      {
        key: "short_name",
        order: 2,
        label: "SHORT_NAME",
        visible: true,
      },
      {
        className: "greyText",
        key: "name",
        order: 3,
        label: "LONG_NAME",
        visible: true,
      },
      {
        key: "nb_uh_r12",
        className: "progressOcc",
        order: 4,
        label: "OCC_SOLD",
        sortingOrder: ["desc", "asc", null],
        type: FormatType.PROGRESS,
        visible: true,
      },
      {
        key: "turnover_r12",
        className: "progressCA",
        order: 5,
        label: "CA_SOLD",
        sortingOrder: ["desc", "asc", null],
        type: FormatType.PROGRESS_CURRENCY,
        visible: true,
      },
      {
        key: "pm_r12",
        className: "progressPM",
        order: 6,
        label: "PM_SOLD",
        sortingOrder: ["desc", "asc", null],
        type: FormatType.PROGRESS_CURRENCY,
        visible: true,
      },
      {
        key: "is_materialization_rate_overridden_past",
        order: 7,
        label: "IS_MATERIALIZATION_RATE_OVERRIDDEN_PAST",
        visible: true,
        rules: [
          {
            type: "compare-with",
            value: false,
            operator: "eq",
            options: {
              color: "text.cell",
            },
          },
          {
            type: "compare-with",
            value: true,
            operator: "eq",
            options: {
              color: "text.accent",
            },
          },
        ],
        type: FormatType.BOOLEAN,
      },
      {
        key: "materialization_rate_past",
        order: 8,
        label: "MATERIALIZATION_RATE_PAST",
        visible: true,
        rules: [
          {
            type: "compare-with",
            column: "is_materialization_rate_overridden_past",
            value: false,
            operator: "eq",
            options: {
              color: "text.cell",
            },
          },
          {
            type: "compare-with",
            column: "is_materialization_rate_overridden_past",
            value: true,
            operator: "eq",
            options: {
              color: "text.accent",
            },
          },
        ],
      },
      {
        key: "is_materialization_rate_overridden_future",
        order: 9,
        label: "IS_MATERIALIZATION_RATE_OVERRIDDEN_FUTURE",
        visible: true,
        rules: [
          {
            type: "compare-with",
            value: false,
            operator: "eq",
            options: {
              color: "text.cell",
            },
          },
          {
            type: "compare-with",
            value: true,
            operator: "eq",
            options: {
              color: "text.accent",
            },
          },
        ],
        type: FormatType.BOOLEAN,
      },
      {
        key: "materialization_rate_future",
        order: 10,
        label: "MATERIALIZATION_RATE_FUTURE",
        visible: true,
        rules: [
          {
            type: "compare-with",
            column: "is_materialization_rate_overridden_future",
            value: false,
            operator: "eq",
            options: {
              color: "text.cell",
            },
          },
          {
            type: "compare-with",
            column: "is_materialization_rate_overridden_future",
            value: true,
            operator: "eq",
            options: {
              color: "text.accent",
            },
          },
        ],
      },
      {
        key: "is_option_materialization_rate_overridden_past",
        order: 11,
        label: "IS_OPTION_MATERIALIZATION_RATE_OVERRIDDEN_PAST",
        visible: true,
        rules: [
          {
            type: "compare-with",
            value: false,
            operator: "eq",
            options: {
              color: "text.cell",
            },
          },
          {
            type: "compare-with",
            value: true,
            operator: "eq",
            options: {
              color: "text.accent",
            },
          },
        ],
        type: FormatType.BOOLEAN,
      },
      {
        key: "option_materialization_rate_past",
        order: 12,
        label: "OPTION_MATERIALIZATION_RATE_PAST",
        visible: true,
        rules: [
          {
            type: "compare-with",
            column: "is_option_materialization_rate_overridden_past",
            value: false,
            operator: "eq",
            options: {
              color: "text.cell",
            },
          },
          {
            type: "compare-with",
            column: "is_option_materialization_rate_overridden_past",
            value: true,
            operator: "eq",
            options: {
              color: "text.accent",
            },
          },
        ],
      },
      {
        key: "is_option_materialization_rate_overridden_future",
        order: 13,
        label: "IS_OPTION_MATERIALIZATION_RATE_OVERRIDDEN_FUTURE",
        visible: true,
        rules: [
          {
            type: "compare-with",
            value: false,
            operator: "eq",
            options: {
              color: "text.cell",
            },
          },
          {
            type: "compare-with",
            value: true,
            operator: "eq",
            options: {
              color: "text.accent",
            },
          },
        ],
        type: FormatType.BOOLEAN,
      },
      {
        key: "option_materialization_rate_future",
        order: 14,
        label: "OPTION_MATERIALIZATION_RATE_FUTURE",
        visible: true,
        rules: [
          {
            type: "compare-with",
            column: "is_option_materialization_rate_overridden_future",
            value: false,
            operator: "eq",
            options: {
              color: "text.cell",
            },
          },
          {
            type: "compare-with",
            column: "is_option_materialization_rate_overridden_future",
            value: true,
            operator: "eq",
            options: {
              color: "text.accent",
            },
          },
        ],
      },
      {
        key: "lead_time_override_global",
        order: 15,
        label: "LEAD_TIME_OVERRIDE_GLOBAL",
        visible: true,
      },
      {
        key: "lead_time_override_model",
        order: 16,
        label: "LEAD_TIME_OVERRIDE_MODEL",
        visible: true,
      },
      {
        key: "exclude_from_model",
        order: 17,
        label: "EXCLUDE_FROM_MODEL",
        visible: true,
        rules: [
          {
            type: "compare-with",
            value: false,
            operator: "eq",
            options: {
              color: "text.cell",
            },
          },
          {
            type: "compare-with",
            value: true,
            operator: "eq",
            options: {
              color: "text.accent",
            },
          },
        ],
        type: FormatType.BOOLEAN,
      },
    ],
    filters: [
      {
        type: ConfigurationTableFilterType.Search,
      },
      {
        type: ConfigurationTableFilterType.ResetButton,
      },
    ],
    export: { path: "/api/customer-types/export" },
  },
  options: {
    formFields: [
      {
        key: "code",
        label: "CODE",
        type: ConfigurationFormType.Input,
      },
      {
        key: "short_name",
        label: "SHORT_NAME",
        type: ConfigurationFormType.Input,
      },
      {
        key: "name",
        label: "LONG_NAME",
        type: ConfigurationFormType.Input,
      },
      {
        key: "is_materialization_rate_overridden_past",
        label: "IS_MATERIALIZATION_RATE_OVERRIDDEN_PAST",
        type: ConfigurationFormType.Check,
      },
      {
        enableField: "is_materialization_rate_overridden_past",
        inputType: "number",
        inputProps: {
          type: "number",
          inputProps: {
            min: 0,
            max: 1,
            step: "any",
          },
        },
        key: "materialization_rate_past",
        label: "MATERIALIZATION_RATE_PAST",
        tooltip: "MATERIALIZATION_RATE_CONDITION",
        type: ConfigurationFormType.Input,
      },
      {
        key: "is_materialization_rate_overridden_future",
        label: "IS_MATERIALIZATION_RATE_OVERRIDDEN_FUTURE",
        type: ConfigurationFormType.Check,
      },
      {
        enableField: "is_materialization_rate_overridden_future",
        inputType: "number",
        inputProps: {
          type: "number",
          inputProps: {
            min: 0,
            max: 1,
            step: "any",
          },
        },
        key: "materialization_rate_future",
        label: "MATERIALIZATION_RATE_FUTURE",
        tooltip: "MATERIALIZATION_RATE_CONDITION",
        type: ConfigurationFormType.Input,
      },
      {
        key: "is_option_materialization_rate_overridden_past",
        label: "IS_OPTION_MATERIALIZATION_RATE_OVERRIDDEN_PAST",
        type: ConfigurationFormType.Check,
      },
      {
        enableField: "is_option_materialization_rate_overridden_past",
        inputType: "number",
        inputProps: {
          type: "number",
          inputProps: {
            min: 0,
            max: 1,
            step: "any",
          },
        },
        key: "option_materialization_rate_past",
        label: "OPTION_MATERIALIZATION_RATE_PAST",
        tooltip: "MATERIALIZATION_RATE_CONDITION",
        type: ConfigurationFormType.Input,
      },
      {
        key: "is_option_materialization_rate_overridden_future",
        label: "IS_OPTION_MATERIALIZATION_RATE_OVERRIDDEN_FUTURE",
        type: ConfigurationFormType.Check,
      },
      {
        enableField: "is_option_materialization_rate_overridden_future",
        inputType: "number",
        inputProps: {
          type: "number",
          inputProps: {
            min: 0,
            max: 1,
            step: "any",
          },
        },
        key: "option_materialization_rate_future",
        label: "OPTION_MATERIALIZATION_RATE_FUTURE",
        tooltip: "MATERIALIZATION_RATE_CONDITION",
        type: ConfigurationFormType.Input,
      },
      {
        key: "lead_time_override_global",
        label: "LEAD_TIME_OVERRIDE_GLOBAL",
        type: ConfigurationFormType.StaticSelect,
      },
      {
        key: "lead_time_override_model",
        label: "LEAD_TIME_OVERRIDE_MODEL",
        type: ConfigurationFormType.StaticSelect,
      },
      {
        key: "exclude_from_model",
        label: "EXCLUDE_FROM_MODEL",
        type: ConfigurationFormType.Check,
      },
    ],
    editOptions: [
      {
        key: "code",
        flex: "50%",
        readonly: true,
      },
      {
        key: "short_name",
        flex: "50%",
        readonly: true,
      },
      {
        key: "name",
        flex: "100%",
        readonly: true,
      },
      {
        key: "is_materialization_rate_overridden_past",
        flex: "50%",
      },
      {
        key: "materialization_rate_past",
        flex: "50%",
      },
      {
        key: "is_materialization_rate_overridden_future",
        flex: "50%",
      },
      {
        key: "materialization_rate_future",
        flex: "50%",
      },
      {
        key: "is_option_materialization_rate_overridden_past",
        flex: "50%",
      },
      {
        key: "option_materialization_rate_past",
        flex: "50%",
      },
      {
        key: "is_option_materialization_rate_overridden_future",
        flex: "50%",
      },
      {
        key: "option_materialization_rate_future",
        flex: "50%",
      },
      {
        key: "lead_time_override_global",
        flex: "50%",
      },
      {
        key: "lead_time_override_model",
        flex: "50%",
      },
      {
        key: "exclude_from_model",
        flex: "50%",
      },
    ],
    creatable: false,
    copyable: false,
    editable: true,
    deletable: false,
  },
};

export const SURQUAL_CUSTOMER_TYPE_PAGE = {
  type: ConfigurationPageType.TABS,
  count: 0,
  description: "CONF_PAGE_DESC_DEFAULT",
  label: "CUSTOMER_TYPE",
  pageLabel: "CUSTOMER_TYPE_TITLE_SURQUAL",
  menuLabel: "CUSTOMER_TYPE",
  name: "Customer type",
  path: "customer-types",
  tabs: [SURQUAL_CUSTOMER_TYPE_PAGE_CUSTOMER_TYPE_TAB],
};
